import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewPermissionsList = (options = {}) => { 
    return useQuery({ 
        queryKey: ['viewPermissionsList'], 
        enabled: options.enabled ?? true,
        staleTime: 0,
        gcTime: 0,
        queryFn: async () => { 
            const res = await api.get('/permissions/my-list'); 
            return res.data; 
        }
     });
};  